<template>
  <div class="pa-login-box">
    <LoginBoxHeader />
    <LoginBoxContent />
  </div>
</template>
<script>
import LoginBoxHeader  from '@/components/FrontParts/LoginModal/LoginBox/header.vue'
import LoginBoxContent from '@/components/FrontParts/LoginModal/LoginBox/content.vue'

export default {
  components  : {
    LoginBoxHeader,
    LoginBoxContent
  }
}
</script>
<style lang="scss">
@import "~bulma/sass/utilities/_all";

div.pa-login-box{
  position: relative;
  border:.8rem solid #89620C;
  border-radius:1rem;
  background-color:#DDCEB3;
  color:#4a4a4a;
  width:95vw;
  margin:3rem auto 0;

  @include until($tablet) {
    border-radius:.4rem;
    border:6px solid #89620C;
    width:95vw;
  }

  @include from($tablet) {
    border:8px solid #89620C;
    width:430px;
  }
}
</style>
